// extracted by mini-css-extract-plugin
export default {"pagination":"styles__pagination--ONgSN","pagination-container":"styles__pagination-container--nPgV7"};